import { hasSelectedFacets, getSort, getPaginationMax } from "./modules/search";
import {
  isFacetedNavPage,
  getCategoryStatusIsNotFound,
  getCategoryDetails,
} from "./modules/category/selectors";
import { getLocation } from "./modules/router/selectors";

const CTA_PATTERNS = ["/cta/", "/ctas/"];

const isCtaPageFromCanonicalUrls = (canonicalUrls, CTA_PATTERNS) =>
  Object.values(canonicalUrls).some(
    (url) =>
      typeof url === "string" &&
      CTA_PATTERNS.some((pattern) => url.toLowerCase().includes(pattern)),
  );

const isCtaPageFromLocation = (location, CTA_PATTERNS) =>
  location?.pathname &&
  CTA_PATTERNS.some((pattern) =>
    location.pathname.toLowerCase().includes(pattern),
  );

export const shouldRenderPagination = (state) => {
  if (getCategoryStatusIsNotFound(state)) {
    return false;
  }

  const category = getCategoryDetails(state);
  const canonicalUrls = category?.canonicalUrls || {};

  const isCtaPage =
    isCtaPageFromCanonicalUrls(canonicalUrls, CTA_PATTERNS) ||
    isCtaPageFromLocation(getLocation(state), CTA_PATTERNS);

  if (isCtaPage) {
    return false;
  }

  const baseCondition =
    (isFacetedNavPage(state) || !hasSelectedFacets(state)) && !getSort(state);

  const maxPage = getPaginationMax(state);
  const hasMultiplePages = typeof maxPage === "number" && maxPage > 1;

  return baseCondition || hasMultiplePages;
};
